<template>
  <div class="flex">
    <div class="search-full-container w-full h-full absolute left-0 top-0" :class="{'flex': showFullSearch}" v-show="showFullSearch">
      <vx-auto-suggest
        ref="navbarSearch"
        :autoFocus="showFullSearch"
        :data="clientsData"
        search_key="title"
        background-overlay
        class="w-full"
        inputClassses="w-full vs-input-no-border vs-input-no-shdow-focus"
        icon="SearchIcon"
        placeholder="Buscar Cliente..."
        @input="hnd_search_query_update"
        @selected="selected"
        @closeSearchbar="showFullSearch = false">

        <template v-slot:group="{ group_name }">
          <p class="font-semibold text-primary">{{ group_name | title }}</p>
        </template>

        <!-- Pages Suggestion -->
        <!-- <template v-slot:pages="{ suggestion }">
          <div class="flex items-end leading-none py-1">
            <feather-icon :icon="suggestion.icon" svgClasses="h-5 w-5" class="mr-4" />
            <span class="mt-1">{{ suggestion.title }}</span>
          </div>
        </template> -->

        <!-- Contacts Suggestion -->
        <template v-slot:clientes="{ suggestion }">
          <div class="flex items-center justify-between">
            <div class="flex items-center">
              <vs-avatar :src="getAvatar(suggestion.avatar_profile_image_user)" :alt="suggestion.names_client" class="flex-shrink-0 mr-2" size="30px" />
              <div class="leading-none mt-1">
                <p>{{ suggestion.names_client }} {{ suggestion.surnames_client }}</p>
                <small>{{ suggestion.email_user }}</small>
              </div>
            </div>
            <small>{{ suggestion.roles.map(item => item.name_role).toString() }}</small>
          </div>
        </template>

        <!-- No Items Slot -->
        <!-- <template v-slot:noResult="{ group_name }">
          <div class="flex items-center">
            <feather-icon icon="InfoIcon" svgClasses="h-5 w-5" class="mr-4" />
            <span>No results found.</span>
          </div>
        </template> -->

      </vx-auto-suggest>

      <div class="absolute right-0 h-full z-50">
        <feather-icon
          icon="XIcon"
          class="px-4 cursor-pointer h-full close-search-icon"
          @click="showFullSearch = false" />
      </div>
    </div>
    <feather-icon icon="SearchIcon" @click="showFullSearch = true" class="cursor-pointer navbar-fuzzy-search ml-4" />
  </div>
</template>

<script>
import VxAutoSuggest from '@/components/vx-auto-suggest/VxAutoSuggest.vue'
import axios from '@/axios.js'

export default {
  components: {
    VxAutoSuggest
  },
  data () {
    return {
      showFullSearch: false
    }
  },
  computed: {
    clientsData () {
      const clientsData = {
        clientes: {
          key: 'email_user',
          data: this.$store.state.clientsPDN
        }
      }
      return clientsData
    }
  },
  methods: {
    getAvatar (avatar) {
      if (avatar === null) return 
      return (axios.defaults.baseURLnoAPI) + avatar
    },
    selected (item) {
      this.showFullSearch = false
      return this.$router.push({name:'admin.cliente', params: {id_client: item.clientes.id_client}}).catch((error) => console.log(error))
      
    },
    hnd_search_query_update (query) {
      // Show overlay if any character is entered
      this.$store.commit('TOGGLE_CONTENT_OVERLAY', !!query)
    }
  }, 
  created () {
    this.$store.dispatch('fetchClientsPDN').catch((error) => { console.log(error) })
  }
}

</script>
